import React from 'react';
import PropTypes from 'prop-types';
import TypeCard from 'components/molecules/TypeCard';
import creativeCampaignSvg from 'images/creativeCampaign.svg';
import customSegmentSvg from 'images/customSegments.svg';
import mbmmSvg from 'images/mbmm.svg';
import { useViewPage } from 'utilities/mixpanel';
import {
  taxonomyCompanyTaxonomiesPath,
  taxonomyCreativeTaxonomiesPath,
  taxonomyCustomSegmentsPath,
  taxonomyUnparsableCampaignsPath,
} from 'utilities/routes';
import styles from 'components/reporting/SelectType.module.css';

const propTypes = {
  canManageCreative: PropTypes.bool.isRequired,
  canManageCustom: PropTypes.bool.isRequired,
  canManageMbmm: PropTypes.bool.isRequired,
  canViewMbmm: PropTypes.bool.isRequired,
};

const customTaxonomyType = {
  description: 'Create your own reporting fields based on the categories used by your company to segment your campaigns',
  key: 'CustomTaxonomy',
  label: 'Custom Reporting',
  url: taxonomyCustomSegmentsPath(),
};

const creativeTaxonomyType = {
  description: 'Organize your creatives by campaign across all markets and platforms',
  key: 'CreativeCampaignTaxonomy',
  label: 'Creative Campaign Reporting',
  url: taxonomyCreativeTaxonomiesPath(),
};

function getSvg(type) {
  switch (type) {
    case 'CustomTaxonomy':
      return customSegmentSvg;
    case 'BrandMarketTaxonomy':
      return mbmmSvg;
    case 'CreativeCampaignTaxonomy':
      return creativeCampaignSvg;
    default:
      return '';
  }
}

function getCompanyTaxonomyPath(canManageMbmm) {
  return canManageMbmm ? taxonomyCompanyTaxonomiesPath() : taxonomyUnparsableCampaignsPath();
}

function getMbmmTaxonomyType(canManageMbmm) {
  return {
    description: 'Report on your brands and markets by setting up a taxonomy rule to search for them in your campaigns',
    key: 'BrandMarketTaxonomy',
    label: 'Multi-Brand / Multi-Market',
    url: getCompanyTaxonomyPath(canManageMbmm),
  };
}

function SelectType({
  canManageCreative,
  canManageCustom,
  canManageMbmm,
  canViewMbmm,
}) {
  useViewPage();

  const typeData = [];

  if (canViewMbmm) {
    typeData.push(getMbmmTaxonomyType(canManageMbmm));
  }

  if (canManageCustom) {
    typeData.push(customTaxonomyType);
  }

  if (canManageCreative) {
    typeData.push(creativeTaxonomyType);
  }

  return (
    <div className={styles.cards}>
      { typeData.map((type) => (
        <TypeCard
          key={type.key}
          description={type.description}
          href={type.url}
          label={type.label}
          svg={getSvg(type.key)}
        />
      )) }
    </div>
  );
}

SelectType.propTypes = propTypes;

export default SelectType;
